// MergeFileContentWithMessages.js

const LOG_PREFIX = '📄 [MergeFiles]'; // Added for clarity

/* ========================
 * formatFileContentForLlm - Formats text file content for LLM injection
 * This function takes rawInputText and file objects (array or object map)
 * It returns a single string ready to be part of processedLlmContent
 * ======================== */
export const formatFileContentForLlm = (rawInputText, files = [], isHistorical = false) => {
    // Convert files object to array if it's not already
    let filesArray = files;
    if (!Array.isArray(files) && typeof files === 'object') {
        filesArray = Object.values(files);
    }

    if (!filesArray || filesArray.length === 0) {
        return rawInputText || ''; // Return raw text if no files
    }

    // Section 1: Handle Images
    const imageUrls = filesArray
        .filter(file => file && file.type?.startsWith('image/') && file.url)
        .map(file => `- ${file.url}`)
        .join('\n');
    
    let imageSection = '';
    if (imageUrls) {
        imageSection = 'Image(s) with this message:\n' + imageUrls;
    }

    // Section 2: Handle Text files (based on original logic)
    const textFiles = filesArray.filter(file => 
        file && 
        typeof file.name === 'string' && 
        (typeof file.content === 'string' || file.contentWithLines) &&
        !file.type?.startsWith('image/') && !file.type?.startsWith('audio/')
    );

    let textFileSection = '';
    if (textFiles.length > 0) {
        textFileSection = textFiles.map(file => {
            let content = `=== ${file.name} ===\n`;
            content += file.contentWithLines || file.content;
            content += `\n=== End of ${file.name} ===`;
            return content;
        }).join('\n\n');
    }

    // Section 3: Combine and build the final string
    const attachmentsBlock = [imageSection, textFileSection].filter(Boolean).join('\n\n');

    if (!attachmentsBlock.trim()) {
        return rawInputText || '';
    }

    let mergedContent = '';
    
    // ARCHITECTURAL FIX: Use a less verbose header for historical messages to avoid
    // repeating the full instruction block multiple times in the context.
    if (isHistorical) {
        mergedContent += '==== PREVIOUSLY ATTACHED FILES ====\n';
    } else {
        mergedContent += '==== USER HAS ATTACHED FILES TO CURRENT MESSAGE - READ EVERY LINE BEFORE RESPONDING ====\n';
        mergedContent += 'ASSISTANT INSTRUCTIONS:\n';
        mergedContent += '- @LINE:n references are automatically injected to match your user\'s editor line numbers\n';
        mergedContent += '- Always use these line numbers for precise code location references in responses\n';
        mergedContent += '- Never include line numbers inside code blocks shared with users\n';
        mergedContent += '- Keep all code blocks clean and paste-ready\n';
        mergedContent += '- Line numbers must only come from @LINE markers - no counting or guessing\n\n';
    }
            
    mergedContent += attachmentsBlock;

    // Only add the user-requested delimiters for the current message to avoid cluttering history.
    if (isHistorical) {
        mergedContent += '\n\n' + (rawInputText || '');
    } else {
        mergedContent += '\n\n==== END OF ATTACHED FILES ====\n\n';
        mergedContent += '==== USER\'S MESSAGE STARTS HERE ====\n\n';
        mergedContent += rawInputText || '';
    }

    return mergedContent;
};